import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import { fetchJSON } from "helpers/axios";
import { connect } from "react-redux";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -7,
    top: 3,
    fontSize: "10px",
    border: `1px solid ${theme.palette.background.paper}`,
    padding: "2px",
  },
}))(Badge);

class StudentMenuList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationCounts: {
        lectureNotes: 0,
        assignments: 0,
        liveClassRoom: 0,
        learningDiscussion: 0,
        announcements: 0,
        exams: 0,
      },
    };
  }

  componentDidMount() {
    const { history, authUser } = this.props;

    const that = this;
    const pathname = `${history.location.pathname}`;

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function () {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
      };
    }

    try {
      const activeLi = document.querySelector(`a[href="${pathname}"]`);
      const activeNav = this.closest(activeLi, "ul");
      if (activeNav?.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}

    if (authUser && authUser.StudId) {
      this.fetchAllNotifications();
    }
  }

  fetchAllNotifications = async () => {
    const { authUser } = this.props;
    if (!authUser || !authUser.StudId) return;

    const { StudId, token } = authUser;

    const notificationTypes = [
      { type: 2, key: "lectureNotes" },
      { type: 3, key: "assignments" },
      { type: 4, key: "liveClassRoom" },
      { type: 5, key: "learningDiscussion" },
      { type: 6, key: "announcements" },
      { type: 7, key: "exams" },
    ];

    await Promise.all(
      notificationTypes.map(({ type, key }) =>
        this.fetchNotificationCount(StudId, token, type, key)
      )
    );
  };

  fetchNotificationCount = async (studId, token, notificationType, stateKey) => {
    try {
      const response = await fetchJSON(
        `api/GetUnReadNotifications?staffId=${studId}&notificationType=${notificationType}`,
        null,
        "GET",
        token
      );

      if (response?.Status === true) {
        this.setState((prev) => ({
          notificationCounts: {
            ...prev.notificationCounts,
            [stateKey]: response?.Data?.length || 0,
          },
        }));
      }
    } catch (error) {}
  };

  markNotificationsAsRead = async (notificationType) => {
    const { authUser } = this.props;
    if (!authUser || !authUser.StudId) return;

    const { StudId, token } = authUser;

    const response = await fetchJSON(
      `api/MarkNotificationsAsRead?staffId=${StudId}&notificationType=${notificationType}`,
      null,
      "POST",
      token
    );

    if (response?.Status === true) {
      this.setState((prev) => ({
        notificationCounts: {
          ...prev.notificationCounts,
          [this.getKeyFromType(notificationType)]: 0,
        },
      }));
    }
  };

  getKeyFromType = (type) => {
    const mapping = {
      2: "lectureNotes",
      3: "assignments",
      4: "liveClassRoom",
      5: "learningDiscussion",
      6: "announcements",
      7: "exams",
    };
    return mapping[type] || "";
  };

  closest(el, selector) {
    while (el) {
      if (el.matches?.(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  renderMenuItemWithBadge = (to, icon, text, notificationType) => {
    const count =
      this.state.notificationCounts[this.getKeyFromType(notificationType)] || 0;

    return (
      <NavLink
        to={to}
        onClick={() => this.markNotificationsAsRead(notificationType)}
      >
        {count > 0 ? (
          <StyledBadge badgeContent={count} color="secondary">
            <i className={`zmdi ${icon} zmdi-hc-fw`} />
            <span className="nav-text">{text}</span>
          </StyledBadge>
        ) : (
          <>
            <i className={`zmdi ${icon} zmdi-hc-fw`} />
            <span className="nav-text">{text}</span>
          </>
        )}
      </NavLink>
    );
  };

  /** 🔒 Disable menu helper */
  renderNavLinkDisabled = (to, icon, text, disabled) => {
    if (disabled) {
      return (
        <NavLink className="prepend-icon" to={to}
          style={{
            opacity: 0.5,
            cursor: "not-allowed",
            pointerEvents: "none",
            // display: "flex",
            // alignItems: "center",
          }}
        >
          <i className={`zmdi ${icon} zmdi-hc-fw`} />
          <span className="nav-text">{text}</span>
        </NavLink>
      );
    }

    return (
      <NavLink className="prepend-icon" to={to}>
        <i className={`zmdi ${icon} zmdi-hc-fw`} />
        <span className="nav-text">{text}</span>
      </NavLink>
    );
  };

  render() {
    const { authUser } = this.props;
    const isProfileUpdated = authUser?.ProfileUpdated === true;

    return (
      <CustomScrollbars className="scrollbar">
        <ul className="nav-menu">
          <li className="nav-header">
            <IntlMessages id="sidebar.menu" />
          </li>

          {/* Dashboard */}
          <li className="menu no-arrow">
            <NavLink to="/student/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.dashboard" />
              </span>
            </NavLink>
          </li>

          {/* Profile */}
          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/profile">
              <i className="zmdi zmdi-account zmdi-hc-fw" />
              <span className="nav-text">Profile</span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            {this.renderNavLinkDisabled(
              "/student/payment",
              "zmdi-card",
              "Fees Payment",
              !isProfileUpdated
            )}
          </li>

          <li className="menu no-arrow">
            {this.renderNavLinkDisabled(
              "/student/courseregistration",
              "zmdi-card",
              "Courses Registration",
              !isProfileUpdated
            )}
          </li>

          <li className="menu no-arrow">
            {this.renderNavLinkDisabled(
              "/student/applyforhostel",
              "zmdi-card",
              "Apply for hostel",
              !isProfileUpdated
            )}
          </li>

          {/* <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/result">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">Result</span>
            </NavLink>
          </li> */}

          <li className="menu no-arrow">
            {this.renderNavLinkDisabled(
              "/student/ReportCard",
              "zmdi-card",
              "Report Card",
              !isProfileUpdated
            )}
          </li>

          {/* <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/courseregistration">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">Courses</span>
            </NavLink>
          </li> */}

          {/* <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/liveclasses",
              "zmdi-graduation-cap",
              "Live Classes",
              4
            )}
          </li> */}

          {/* <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/exams",
              "zmdi-graduation-cap",
              "Exams",
              7
            )}
          </li> */}

          {/* <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/lecturenote",
              "zmdi-graduation-cap",
              "Lecturer Note",
              2
            )}
          </li> */}

          {/* <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/discussion",
              "zmdi-graduation-cap",
              "Discussion",
              5
            )}
          </li> */}

          {/* <li className="menu no-arrow">
            {this.renderMenuItemWithBadge(
              "/student/assignment",
              "zmdi-graduation-cap",
              "Assignment",
              3
            )}
          </li> */}

          <li className="menu no-arrow">
            <NavLink to="/student/changepassword">
              <i className="zmdi zmdi-key zmdi-hc-fw" />
              <span className="nav-text">Change Password</span>
            </NavLink>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  authUser: auth.studentUser,
});

export default withRouter(connect(mapStateToProps)(StudentMenuList));
